import styled from 'styled-components';
import colors from '../../../helpers/colors';
import fonts from '../../../helpers/fonts';
import mediaQuery from '../../../helpers/mediaQuery';
import spacing, { spacingWithBorder } from '../../../helpers/spacing';
import Icon from '../../Icon';
import LazyImg from '../../LazyImg';
import RichText from '../../RichText';

const borderPx = 1;

type InfoCardContainerProps = {
  displayBackground?: boolean;
};

export const InfoCardContainer = styled.div<InfoCardContainerProps>`
  display: flex;
  flex-flow: column nowrap;
  background-color: ${({ displayBackground }) =>
    displayBackground ? colors.neutral08 : 'initial'};
  position: ${({ displayBackground }) => (displayBackground ? 'relative' : 'initial')};

  margin: ${spacing(1)} 0;

  padding: ${spacingWithBorder(4, borderPx)} ${spacingWithBorder(3, borderPx)};
  border: ${borderPx}px solid ${colors.cardBorder};
  border-radius: ${({ theme }) => `${theme.cardRadius}`};

  ${mediaQuery.tabletLandscape`
    margin: ${spacing(2)} 0;
    padding: ${spacingWithBorder(4, borderPx)};
  `}
`;

export const Heading = styled.div`
  ${fonts.headingSmall}
  display: flex;

  ${Icon} {
    color: ${colors.cardIcon};
    margin-right: ${spacing(2)};
    flex: 0 0 ${spacing(4)};
  }
`;

export const InfoCardRichText = styled(RichText)`
  margin: ${spacing(2)} 0 0;
`;

export const CtaWrapper = styled.div`
  margin-top: auto;
  padding-top: ${spacing(4)};
`;

export const LogoImage = styled(LazyImg)`
  align-self: flex-start;
  margin: ${spacing(2)} 0 0;
  max-height: ${spacing(4)};
`;
